 <ngx-dynamic-hooks #hooksEl class="RenderMath" [class.hideStudentManipControlBar]="hideStudentManipControlBar" [parsers]="dynamicComponents" [content]="questionText" [context]="dynamicContext" [options]="dynamicOptions"></ngx-dynamic-hooks>



